import AutomationsColumn from '../Columns/AutomationsColumn';
import React from 'react';
import { AutomationRunStatus, UpdateUserBoardFilterSettingsMutationFn } from 'shared/types/graphql';
import { Appointment } from 'pages/Board';
import { HStack } from '@televet/kibble-ui/build/chakra';

type AutomationStatusBoardProps = {
  clinicId?: string;
  onEditAppointment: (appointment: Partial<Appointment>) => void;
  unreadChannelIds?: string[];
  updateBoardSettings: UpdateUserBoardFilterSettingsMutationFn;
};

const statusBgColorMap: Record<AutomationRunStatus, string> = {
  [AutomationRunStatus.Sent]: '#6E6D87',
  [AutomationRunStatus.Started]: '#D69E2E',
  [AutomationRunStatus.Completed]: '#25855A',
};

const statusNameMap: Record<AutomationRunStatus, string> = {
  [AutomationRunStatus.Sent]: 'Not Started',
  [AutomationRunStatus.Started]: 'In Progress',
  [AutomationRunStatus.Completed]: 'Complete',
};

const AutomationStatusBoard = ({
  onEditAppointment,
  unreadChannelIds,
  updateBoardSettings,
}: AutomationStatusBoardProps): JSX.Element => {
  const automationStatuses = [AutomationRunStatus.Sent, AutomationRunStatus.Started, AutomationRunStatus.Completed];

  return (
    <HStack className="Board__Columns--ScrollContainer" h="100%" w="100%" spacing={4} overflowX="hidden" py={2} px={4}>
      <>
        {automationStatuses.map((AutomationRunStatus) => (
          <AutomationsColumn
            key={`automation-status-${AutomationRunStatus}`}
            columnName={statusNameMap[AutomationRunStatus]}
            columnColor={statusBgColorMap[AutomationRunStatus]}
            automationRunStatus={AutomationRunStatus}
            onEditAppointment={onEditAppointment}
            unreadChannelIds={unreadChannelIds}
            updateBoardSettings={updateBoardSettings}
          />
        ))}
      </>
    </HStack>
  );
};

export default AutomationStatusBoard;
